import { useState } from 'react'
import uniqid from 'uniqid'
import { skills } from '../../portfolio'
import './Skills.css'


const Skills = () => {
  const [selectedSkill, setSelectedSkill] = useState(null)

  if (!skills.length) return null

  const handleSkillClick = (skill) => {
    setSelectedSkill(skill) // open popup with this skill
  }

  const closePopup = () => {
    setSelectedSkill(null)
  }

  return (
    <section className='section skills' id='interests'>
      <h2 className='section__title'>Interests</h2>
      <ul className='skills__list'>
        {skills.map((skill) => (
        <li
          key={uniqid()} 
          className='skills__list-item'
        >
          <button
            type="button"
            className='btn btn--plain'
            onClick={() => handleSkillClick(skill)}
          >
            {skill.name || skill }
          </button>
        </li>
        ))}
      </ul>

      {/* Popup */}
      {selectedSkill && selectedSkill.image && (
        <div className='popup-overlay'>
          <div className='popup'>
            <button
                type="button"
                className='close-btn'
                onClick={closePopup}
                aria-label="Close popup"
              >
              ×
            </button>
            <img src={selectedSkill.image} alt={selectedSkill.name}/>
            {selectedSkill.caption && <p>{selectedSkill.caption}</p>}
          </div>
        </div>
      )}
    </section>
  )
}

export default Skills
